import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import * as _ from 'lodash';

import 'react-select/dist/react-select.css';

const reduxEnhancer = connect(
  store => ({
    fleets: store.fleetState.fleets,
  }),
  null,
);

const FleetSelect = ({ fleets, ...props }) => (
  <Select
    options={
      _.map(fleets, ({ name }, id) => ({ value: id, label: name }))
    }
    simpleValue
    {...props}
  />
);

FleetSelect.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  fleets: PropTypes.object,
};

FleetSelect.defaultProps = {
  id: 'fleet',
  placeholder: 'Selecione uma frota',
  fleets: {},
};

export default reduxEnhancer(FleetSelect);



// WEBPACK FOOTER //
// ./src/Fleet/FleetSelect.js